import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';
import { Representante } from '../../pessoa/representante';

/** Representa o Filter da entidade Regiao */
export class RegiaoFilter implements Filter {
    filterPsq: string;
    idRepresentante: number;
    representante: Representante;
    idEstado: number;
    situacoes: number[] = [];

    constructor(situacoes: number[] = []) {
        this.situacoes = situacoes;
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // Representante
        if (this.idRepresentante) {
            params = params.append('idRepresentante', this.idRepresentante.toString());
        }
        // Estado
        if (this.idEstado) {
            params = params.append('idEstado', this.idEstado.toString());
        }
        // Situações
        this.situacoes?.forEach(situacao => {
            params = params.append('situacao', situacao.toString());
        });

        return params;
    }

    clear() {
        this.filterPsq = null;
        this.idRepresentante = null;
        this.representante = null;
        this.idEstado = null;
        this.situacoes = [];
    }
}

